import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { CheckoutBookingPeriod } from './models/checkout-booking-period.model';
import { BookingRequest } from '@app/shared/models/bookingRequest';
import { Booking } from '@app/shared/models/booking';
import { skipErrorSnackbar } from '@core/http-interceptors/skip-error-snackbar';

// Endpoint root
const APIURL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private readonly http = inject(HttpClient);

  getBooking(id: number): Observable<Booking> {
    return this.http.get<Booking>(`${APIURL}/bookings/${id}?expand=bookingPeriods`);
  }

  getBookingByUid(uid: string): Observable<Booking> {
    return this.http.get<Booking>(`${APIURL}/bookings/:get_by_uid?uid=${uid}&expand=bookingPeriods`);
  }

  updateBooking(id: number, payload: BookingRequest): Observable<Booking> {
    return this.http.put<Booking>(`${APIURL}/bookings/${id}`, payload);
  }

  createBooking(payload: BookingRequest): Observable<Booking> {
    return this.http.post<Booking>(`${APIURL}/bookings`, payload);
  }

  /**
   * @param options.showsRejectionItself Kurven skriver selv API'ets begrundelse under knappen, hvor
   * tiderne kan rettes — en snackbar med samme sætning ville sige det samme to gange. Et kaldested
   * uden sin egen visning (Arrangement) sender `false` og får afvisningen som snackbar, som andre steder.
   */
  addBookingPeriod(
    payload: CheckoutBookingPeriod,
    { showsRejectionItself = true }: { showsRejectionItself?: boolean } = {},
  ): Observable<unknown> {
    return this.http.post(
      `${APIURL}/bookingperiods`,
      payload,
      showsRejectionItself ? { context: skipErrorSnackbar() } : {},
    );
  }

  completeBooking(id: number): Observable<unknown> {
    return this.http.post(`${APIURL}/bookings/${id}/complete_booking?notify_email=true`, null);
  }

  deleteBooking(id: number): Observable<unknown> {
    return this.http.delete(`${APIURL}/bookings/${id}`);
  }

  submitBookingApproval(id: number): Observable<unknown> {
    return this.http.post(`${APIURL}/bookings/${id}/submit_booking_approval?notify_email=true`, null);
  }
}
